import React from 'react';
import { Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import FormularioCliente from '../../components/clientes/FormularioCliente';

const FichaCliente = () => {
  return (
    <Col md="12">
      <ComponentCard title="Ficha de Cliente" hasButton>
        <FormularioCliente />
      </ComponentCard>
    </Col>
  );
};

export default FichaCliente;
